module.exports = __webpack_public_path__ + "assets/cancel-fill.30d3a417.svg";